// src/utils/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // "document.documentElement.scrollTo" is the modern routing for scrolling to top of page
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // or "smooth" if you want a smooth scroll
    });
  }, [pathname]); // Re-run this effect whenever the pathname changes

  return null; // This component doesn't render anything itself
}

export default ScrollToTop;